module.exports = __webpack_public_path__ + "static/scale-model-of-reid-park-zoo-in-tucson-arizona-02deb0f1940856aa05c8027638e319c2.png";